import { useEffect, useState } from "react";
import "./styles/styles.scss";
import Navigation from "./Navigation/Routes";
import ModalCart from "./components/Modal/ModalCart";
import ModalWishlist from "./components/Modal/ModalWishlist";
import ModalQuickview from "./components/Modal/ModalQuickview";
import ModalCompare from "./components/Modal/ModalCompare";
import { ModalCartProvider } from "./context/ModalCartContext";
import { CartProvider } from "./context/CartContext";
import { ModalWishlistProvider } from "./context/ModalWishlistContext";
import { ModalSearchProvider } from "./context/ModalSearchContext";
import { WishlistProvider } from "./context/WishlistContext";
import { CompareProvider } from "./context/CompareContext";
import { ModalCompareProvider } from "./context/ModalCompareContext";
import { ModalQuickviewProvider } from "./context/ModalQuickviewContext";
import { ToastProvider } from "./context/ToastContext";
import { WhatsAppChatProvider } from "./context/WhatsAppChatContext";
import { enhanceNavigation } from "./utils/navigationUtils";
import UnderConstruction from "./Pages/under-construction/page";
import { fetchProductText } from "./data/Productlist";
import { getApiUrl } from "./config/api";
import { applyDefaultSiteSeo } from "./utils/siteSeo";

const App = () => {
  const password = "dashboard.kissariti.ma-2025-2026";

  const [show, setShow] = useState(false);
  const [keyword, setKeyword] = useState("");
  const [error, setError] = useState("");
  const [isMaintenanceMode, setIsMaintenanceMode] = useState(false);
  const [isLoadingMaintenance, setIsLoadingMaintenance] = useState(true);

  useEffect(() => {
    applyDefaultSiteSeo();

    const localShow = localStorage.getItem("show");
    if (localShow === "true") {
      setShow(true);
    }

    // Check underconstruction table: status 0 = show site, status 1 = show under construction page
    const checkMaintenanceMode = async () => {
      try {
        // Use same-origin URL when app is served from API domain to avoid CORS issues
        const apiOrigin = 'https://www.kissariti.ma';
        const url =
          typeof window !== 'undefined' && window.location.origin === apiOrigin
            ? '/api/status.php'
            : getApiUrl('STATUS');
        const response = await fetch(url, {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' },
          mode: 'cors',
        });

        if (!response.ok) {
          setIsMaintenanceMode(false);
          return;
        }

        const data = await response.json();
        // Accept both number 1 and string "1" from API
        const status = data != null && data.hasOwnProperty('status')
          ? Number(data.status)
          : 0;
        setIsMaintenanceMode(status === 1);
      } catch {
        setIsMaintenanceMode(false);
      } finally {
        setIsLoadingMaintenance(false);
      }
    };

    checkMaintenanceMode();

    // Enhance navigation to prevent blank pages
    const cleanup = enhanceNavigation();

    return () => {
      cleanup();
    };
  }, []);

  function subFunc() {
    if (keyword === password) {
      localStorage.setItem("show", "true");
      setShow(true);
    } else {
      localStorage.setItem("show", "false");
      setError("Incorrect password");
    }
  }

  /*if (!show) {
    return (
      <div className="flex justify-center items-center h-screen bg-gray-100">
        <div>
        <div className="flex items-center gap-4 p-6 rounded-2xl shadow-xl bg-white">
          <input
            type="text"
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            className="px-4 py-2 border border-gray-400 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600 text-gray-800"
            placeholder="Enter password"
            style={{ backgroundColor: "#ffe4e6" }}
          />
          <button
            onClick={subFunc}
            className="px-5 py-2 text-white font-semibold rounded-lg transition duration-300"
            style={{ backgroundColor: "#ec4899" }}
          >
            Submit
          </button>
        </div>
        {error?<div className="w-full text-white p-2 rounded-md text-center" style={{ backgroundColor: "red" }}>{error}</div>:null}
        </div>
      </div>
    );
  }*/

  // Prefetch product list so home page is fast (cache warmed in background)
  useEffect(() => {
    if (isLoadingMaintenance || isMaintenanceMode) return;
    const t = setTimeout(() => {
      fetchProductText().catch(() => {});
    }, 600);
    return () => clearTimeout(t);
  }, [isLoadingMaintenance, isMaintenanceMode]);

  // Show loading while checking maintenance mode
  if (isLoadingMaintenance) {
    return (
      <div className="flex justify-center items-center h-screen bg-gradient-to-br from-pink-50 to-white">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-pink-500 mx-auto mb-4"></div>
          <p className="text-gray-600 text-lg">Chargement...</p>
        </div>
      </div>
    );
  }

  // Show maintenance page if maintenance mode is active
  if (isMaintenanceMode) {
    return <UnderConstruction />;
  }

  return (
    <ToastProvider>
      <WhatsAppChatProvider>
        <CartProvider>
          <ModalCartProvider>
            <WishlistProvider>
              <ModalWishlistProvider>
                <CompareProvider>
                  <ModalCompareProvider>
                    <ModalSearchProvider>
                      <ModalQuickviewProvider>
                        <ModalCart />
                        <ModalWishlist />
                        <ModalQuickview />
                        <ModalCompare />
                        <Navigation />
                      </ModalQuickviewProvider>
                    </ModalSearchProvider>
                  </ModalCompareProvider>
                </CompareProvider>
              </ModalWishlistProvider>
            </WishlistProvider>
          </ModalCartProvider>
        </CartProvider>
      </WhatsAppChatProvider>
    </ToastProvider>
  );
};

export default App;
